// types
// styles
import React from 'react';
import { observer } from 'mobx-react-lite';
import { CheckListType } from './checkbox-list/checkbox-list';
import styles from './checkbox.module.scss';

type CheckboxType = {
  id: string;
  item: CheckListType;
  size?: 'small' | 'regular' | undefined;
  type?: 'round' | 'action' | 'action-transparent' | undefined;
  boxHighlight?: boolean;
  uncheckedIcon?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = observer<CheckboxType>(({ item, onChange, size = 'regular', type, boxHighlight = false, uncheckedIcon }) => {
  return (
    <label
      className={`d-flex align-items-center position-relative text-${size} ${styles.container} ${
        boxHighlight && styles.boxHighlight
      } ${item.isChecked && styles.checked}`}
    >
      <input type="checkbox" id={item.id} checked={item.isChecked} value={item.name} onChange={onChange} />
      <span className={`${styles.checkmark} ${type ? styles[type] : ''}`}>
        {item.isChecked && <i className="icon-tick" />}
        {!item.isChecked && uncheckedIcon && <i className={uncheckedIcon} />}
      </span>
      {item.name && (
        <div className="d-flex justify-content-between flex-grow-1 align-items-center text-break">
          <span>{item.name}</span>
          {item.descIcon && <i className={`${styles.descIcon} ${item.descIcon}`} />}
        </div>
      )}
    </label>
  );
});
export default Checkbox;